import {call, put} from 'redux-saga/effects';
import {takeEvery} from 'redux-saga';
import UserApi from '../api';
import * as Actions from './actions';
import * as Types from './actions.types';
import * as ResponseActions from '../../common/redux/actions.responseStatus';

export default function* publicProfileFlow() {
  yield [takeEvery(Types.PUBLIC_PROFILE_GET, getPublicProfile)];
}

function* getPublicProfile(action) {
  const {id} = action;

  try {
    const user = yield call(UserApi.getUser, id);
    yield put(Actions.getPublicProfileSuccess(user));
  } catch (error) {
    yield put(Actions.getPublicProfileFailure(error));
    yield put(ResponseActions.setResponseStatus(404));
  }
}



// WEBPACK FOOTER //
// ./shared/publicUser/redux/sagas.js